export default __webpack_public_path__ + "static/media/work-day-scheduler.f873a500.png";